export default {"src":"/_next/static/media/safe.38b57c03.svg","height":36,"width":31};